import { courseConstants } from '../constants/courses'
import { db } from '../../config/firebaseconfig'
import uuid from 'uuid/v1';

export const courses = {
  getCourse,
  toggleCourseStatus,
  getCourseSubcourses,
  createSubcourse,
  updateIndexSubCourse,
  updateCourseName,
  updateCourseDisplayName,
  fetchAllCourses,
  deleteCourse,
  addCourse,
  toggleSubcourseStatus,
  toggleSectionStatus,
  toggleLessonStatus,
  createSection,
  getSection,
  createLesson,
  getLesson,
  updateIndexSection,
  updateIndexLesson,
  deleteSubcourse,
  deleteSection,
  deleteLesson,
  setSectionNode,
  setSubcourseNode,
}

function addCourse(authorId, name, displayName) {
  return dispatch => {
    dispatch(request());
    try {
      const courseId = uuid();
      const newCourse = {
        created: new Date().getTime(),
        lastModified: new Date().getTime(),
        id: courseId,
        published: false,
        node: "",
        subcourses: {},
        licenses: {},
        authorId,
        name,
        displayName
      };
      db.collection("courses")
        .doc(courseId)
        .set(newCourse)
        .then(value => {
          // fetchAllCourses(authorId);
          dispatch(success());
        });
    } catch (err) {
      dispatch(failure(`Failed to Add course`));
    }
  };
  function request() {
    return { type: courseConstants.ADD_COURSE_REQUEST };
  }
  function success() {
    return { type: courseConstants.ADD_COURSE_SUCCESS };
  }
  function failure(error) {
    return { type: courseConstants.ADD_COURSE_FAILURE, error };
  }
}

function getCourse(courseId) {
  return dispatch => {
    dispatch(request())
    db.collection('courses').doc(courseId).get()
      .then(doc => {
        let course = doc.data()
        if (!course.deleted) {
          return dispatch(success(course))
        } else {
          return dispatch(failure('error'))
        }
      })
      .catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })
  }

  function request() { return { type: courseConstants.GET_COURSE_REQUEST } }
  function success(course) { return { type: courseConstants.GET_COURSE_SUCCESS, course } }
  function failure(error) { return { type: courseConstants.GET_COURSE_REQUEST, error } }
}

function toggleCourseStatus(courseId, status) {
  return dispatch => {
    dispatch(request())
    db.collection('courses').doc(courseId).update({ published: !status })
      .then(doc => {
        return dispatch(success())
      })
      .catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })
  }

  function request() { return { type: courseConstants.TOGGLE_COURSE_STATUS_REQUEST } }
  function success() { return { type: courseConstants.TOGGLE_COURSE_STATUS_SUCCESS } }
  function failure(error) { return { type: courseConstants.TOGGLE_COURSE_STATUS_FAILURE, error } }
}
function updateCourseName(courseId, newName) {
  return dispatch => {
    dispatch(request());
    db.collection("courses")
      .doc(courseId)
      .update({ name: newName })
      .then(doc => {
        return dispatch(success());
      })
      .catch(err => {
        console.log(err);
        return dispatch(failure(err));
      });
  };
  function request() {
    return { type: courseConstants.CHANGE_COURSE_NAME_REQUEST };
  }
  function success() {
    return { type: courseConstants.CHANGE_COURSE_NAME_SUCCESS };
  }
  function failure(error) {
    return { type: courseConstants.CHANGE_COURSE_NAME_FAILURE, error };
  }
}
function updateCourseDisplayName(courseId, newDisplayname) {
  return dispatch => {
    dispatch(request());
    db.collection("courses")
      .doc(courseId)
      .update({ displayName: newDisplayname })
      .then(doc => {
        return dispatch(success());
      })
      .catch(err => {
        console.log(err);
        return dispatch(failure(err));
      });
  };
  function request() {
    return { type: courseConstants.CHANGE_COURSE_DISPLAY_NAME_REQUEST };
  }
  function success(course) {
    return { type: courseConstants.CHANGE_COURSE_DISPLAY_NAME_SUCCESS, course };
  }
  function failure(error) {
    return { type: courseConstants.CHANGE_COURSE_DISPLAY_NAME_FAILURE, error };
  }
}

function fetchAllCourses(authorId) {
  return dispatch => {
    dispatch(request());
    try {
      db.collection("courses")
        .where("authorId", "==", authorId)
        .onSnapshot(querySnapshot => {
          let courses = [];
          querySnapshot.forEach(doc => {
            if (doc.exists) {
              const data = doc.data();
              if (!data.deleted) {
                courses.push(data);
              }
            }
          });
          dispatch(success(courses));
        });
    } catch (err) {
      dispatch(failure(err));
    }
  };
  function request() {
    return { type: courseConstants.GET_COURSES_REQUEST };
  }
  function success(courses) {
    return { type: courseConstants.GET_COURSES_SUCCESS, courses };
  }
  function failure(error) {
    return { type: courseConstants.GET_COURSES_FAILURE, error };
  }
}

function deleteCourse(courseId) {
  return dispatch => {
    dispatch(request());
    try {
      db.collection("courses")
        .doc(courseId)
        .update({ deleted: true })
        .then(val => {
          dispatch(success());
        });
    } catch (err) {
      dispatch(
        failure(
          `Failed Delete! Course with id ${courseId} is not deleted: => ${err} `
        )
      );
    }
  };
  function request() {
    return { type: courseConstants.DELETE_COURSE_REQUEST };
  }
  function success() {
    return { type: courseConstants.DELETE_COURSE_REQUEST };
  }
  function failure(error) {
    return { type: courseConstants.DELETE_COURSE_REQUEST, error };
  }
}

function getCourseSubcourses(courseId) {
  return dispatch => {
    dispatch(request())
    let subcourses = []
    db.collection('subcourses').where('courseId', '==', courseId).get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let data = doc.data()
          if (!data.deleted) { subcourses.push(data) }
        })
        return dispatch(success(subcourses))
      }).catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })
  }

  function request() { return { type: courseConstants.GET_COURSE_SUBCOURSES_REQUEST } }
  function success(subcourses) { return { type: courseConstants.GET_COURSE_SUBCOURSES_SUCCESS, subcourses } }
  function failure(error) { return { type: courseConstants.GET_COURSE_SUBCOURSES_FAILURE, error } }
}

function createSubcourse(subcourse, course) {
  return dispatch => {
    dispatch(request())
    let id = uuid()
    let courseObj = {
      ...course,
      subcourses: {
        ...course.subcourses,
        [id]: (course.subcourses ? (Object.values(course.subcourses).filter(index => index !== "-1").length + 1) : 1)
      }
    }
    let subcourseObj = {
      ...subcourse,
      id,
      created: new Date().getTime(),
      lastModified: new Date().getTime(),
      published: false,
      sections: {}
    }
    db.collection('subcourses').doc(id).set(subcourseObj).then(() => {
      db.collection('courses').doc(course.id).set(courseObj).then(() => {
        return dispatch(success({ subcourse: subcourseObj, course: courseObj }))

      }, error => {
        return dispatch(failure(error))
      }
      ), error => {
        return dispatch(failure(error))
      }
    })

  }

  function request() { return { type: courseConstants.CREATE_SUBCOURSE_REQUEST } }
  function success(subcourse) { return { type: courseConstants.CREATE_SUBCOURSE_SUCCESS, subcourse } }
  function failure(error) { return { type: courseConstants.CREATE_SUBCOURSE_FAILURE, error } }
}


function updateIndexSubCourse(courseId, indexes) {
  return dispatch => {
    dispatch(request())
    const batch = db.batch()
    const courseRef = db.collection('courses').doc(courseId)

    indexes.forEach(subcourse => {
      const subcourseKey = `subcourses.${subcourse.id}`
      batch.update(courseRef, { [subcourseKey]: subcourse.index })
    })

    batch.commit().then((val) => {
      return dispatch(success(val))
    }).catch(err => {
      return dispatch(failure(err))
    })

  }

  function request() { return { type: courseConstants.UPDATE_INDEX_SUBCOURSE_REQUEST } }
  function success(subcourse) { return { type: courseConstants.UPDATE_INDEX_SUBCOURSE_SUCCESS, subcourse } }
  function failure(error) { return { type: courseConstants.UPDATE_INDEX_SUBCOURSE_FAILED, error } }
}


function toggleSubcourseStatus(subcourseId, status) {
  return dispatch => {
    dispatch(request())
    db.collection('subcourses').doc(subcourseId).update({ 'published': !!status })
      .then(() => {
        return dispatch(success({ subcourseId, status }))
      }).catch(err => {
        return dispatch(failure(err))

      })
  }
  function request() { return { type: courseConstants.TOGGLE_SUBCOURSE_STATUS_REQUEST } }
  function success(subcourse) { return { type: courseConstants.TOGGLE_SUBCOURSE_STATUS_SUCCESS, subcourse } }
  function failure(error) { return { type: courseConstants.TOGGLE_SUBCOURSE_STATUS_FAILURE, error } }
}

function toggleSectionStatus(section, status) {
  return dispatch => {
    dispatch(request())
    db.collection('sections').doc(section.id).update({ 'published': !!status })
      .then(() => {
        return dispatch(success({ section, status }))
      }).catch(err => {
        return dispatch(failure(err))

      })
  }
  function request() { return { type: courseConstants.TOGGLE_SECTION_STATUS_REQUEST } }
  function success(section) { return { type: courseConstants.TOGGLE_SECTION_STATUS_SUCCESS, section } }
  function failure(error) { return { type: courseConstants.TOGGLE_SECTION_STATUS_FAILURE, error } }
}

function toggleLessonStatus(lesson, status) {
  return dispatch => {
    dispatch(request())
    db.collection('lessons').doc(lesson.id).update({ 'published': !!status })
      .then(() => {
        return dispatch(success({ lesson, status }))
      }).catch(err => {
        return dispatch(failure(err))

      })
  }
  function request() { return { type: courseConstants.TOGGLE_LESSON_STATUS_REQUEST } }
  function success(lesson) { return { type: courseConstants.TOGGLE_COURSE_STATUS_SUCCESS, lesson } }
  function failure(error) { return { type: courseConstants.TOGGLE_COURSE_STATUS_FAILURE, error } }
}


function createSection(section, subcourse) {
  return dispatch => {
    dispatch(request())
    let id = uuid()
    let subcourseObj = {
      ...subcourse,
      sections: {
        ...subcourse.sections,
        [id]: (subcourse.sections ? (Object.values(subcourse.sections).filter(index => index !== "-1").length + 1) : 1)
      }
    }
    let sectionObj = {
      ...section,
      id,
      created: new Date().getTime(),
      lastModified: new Date().getTime(),
      published: false,
      lessons: {},
      node: '',
      subcourseId: subcourse.id
    }

    db.collection('sections').doc(id).set(sectionObj).then(() => {
      db.collection('subcourses').doc(subcourse.id).set(subcourseObj).then(() => {
        return dispatch(success(sectionObj))

      }, error => {
        return dispatch(failure(error))
      }
      ), error => {
        return dispatch(failure(error))
      }
    })

  }


  function request() { return { type: courseConstants.CREATE_SECTION_REQUEST } }
  function success(section) { return { type: courseConstants.CREATE_SECTION_SUCCESS, section } }
  function failure(error) { return { type: courseConstants.CREATE_SECTION_FAILURE, error } }
}

function getSection(subcourseId) {

  return dispatch => {
    dispatch(request())
    let section = []
    db.collection('sections').where('subcourseId', '==', subcourseId).get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let data = doc.data()
          if (!data.deleted) { section.push(data) }
        })
        return dispatch(success(section))
      }).catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })

  }
  function request() { return { type: courseConstants.GET_SECTION_REQUEST } }
  function success(section) { return { type: courseConstants.GET_SECTION_SUCCESS, section } }
  function failure(error) { return { type: courseConstants.GET_SECTION_FAILURE, error } }


}



function createLesson(lesson, section) {
  return dispatch => {
    dispatch(request())
    let id = uuid()
    let sectionObj = {
      ...section,
      lessons: {
        ...section.lessons,
        [id]: (section.lessons ? (Object.values(section.lessons).filter(index => index !== "-1").length + 1) : 1)
      }
    }
    let lessonObj = {
      ...lesson,
      id,
      created: new Date().getTime(),
      lastModified: new Date().getTime(),
      published: false,
      interactionBank: '',
      itemBank: '',
      node: {},
      rules: '',
      sectionId: section.id,
      subcourseId: section.subcourseId,
      courseId: section.courseId,
    }

    db.collection('lessons').doc(id).set(lessonObj).then(() => {
      db.collection('sections').doc(section.id).set(sectionObj).then(() => {
        return dispatch(success(lessonObj))

      }, error => {
        return dispatch(failure(error))
      }
      ), error => {
        return dispatch(failure(error))
      }
    })

  }


  function request() { return { type: courseConstants.CREATE_LESSON_REQUEST } }
  function success(lesson) { return { type: courseConstants.CREATE_LESSON_SUCCESS, lesson } }
  function failure(error) { return { type: courseConstants.CREATE_LESSON_FAILURE, error } }
}



function getLesson(sectionId) {

  return dispatch => {
    dispatch(request())
    let lessons = []
    db.collection('lessons').where('sectionId', '==', sectionId).get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let data = doc.data()
          if (!data.deleted) lessons.push(data)
        })
         return dispatch(success(lessons))
      }).catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })

  }
  function request() { return { type: courseConstants.GET_LESSON_REQUEST } }
  function success(lesson) { return { type: courseConstants.GET_LESSON_SUCCESS, lesson } }
  function failure(error) { return { type: courseConstants.GET_LESSON_FAILURE, error } }


}

function updateIndexSection(subcourseId, indexes) {
  return dispatch => {
    dispatch(request())
    const batch = db.batch()
    const subcourseRef = db.collection('subcourses').doc(subcourseId)
    indexes.forEach(section => {
      const subcourseKey = `sections.${section.id}`
      batch.update(subcourseRef, { [subcourseKey]: section.index })
    })

    batch.commit().then((val) => {
      return dispatch(success(val))
    }).catch(err => {
      return dispatch(failure(err))
    })

  }

  function request() { return { type: courseConstants.UPDATE_INDEX_SECTION_REQUEST } }
  function success(section) { return { type: courseConstants.UPDATE_INDEX_SECTION_SUCCESS, section } }
  function failure(error) { return { type: courseConstants.UPDATE_INDEX_SECTION_FAILED, error } }
}

function updateIndexLesson(sectionId, indexes) {
  return dispatch => {
    dispatch(request())
    const batch = db.batch()
    const sectionRef = db.collection('sections').doc(sectionId)
    indexes.forEach(lesson => {
      const licenseKey = `lessons.${lesson.id}`
      batch.update(sectionRef, { [licenseKey]: lesson.index })
    })

    batch.commit().then((val) => {
      return dispatch(success(val))
    }).catch(err => {
      return dispatch(failure(err))
    })

  }

  function request() { return { type: courseConstants.UPDATE_INDEX_LESSON_REQUEST } }
  function success(lesson) { return { type: courseConstants.UPDATE_INDEX_LESSON_SUCCESS, lesson } }
  function failure(error) { return { type: courseConstants.UPDATE_INDEX_LESSON_FAILED, error } }
}


function deleteSubcourse(subcourseId, courseId) {
  return dispatch => {
    dispatch(request());
    try {
      db.collection("subcourses")
        .doc(subcourseId)
        .update({ deleted: true })
        .then(val => {
          const subcourseKey = `subcourses.${subcourseId}`
          db.collection('courses').doc(courseId).update({ [subcourseKey]: '-1' })
          return dispatch(success(subcourseId));
        });
    } catch (err) {
      return dispatch(
        failure(err)
      );
    }
  };
  function request() {
    return { type: courseConstants.DELETE_SUBCOURSE_REQUEST };
  }
  function success(subcourse) {
    return { type: courseConstants.DELETE_SUBCOURSE_SUCCESS, subcourse };
  }
  function failure(error) {
    return { type: courseConstants.DELETE_SUBCOURSE_FAILURE, error };
  }
}


function deleteSection(sectionId, subcourseId) {
  return dispatch => {
    dispatch(request());
    try {
      db.collection("sections")
        .doc(sectionId)
        .update({ deleted: true })
        .then(val => {
          const sectionKey = `sections.${sectionId}`
          db.collection('subcourses').doc(subcourseId).update({ [sectionKey]: '-1' })
          return dispatch(success({ sectionId, subcourseId }));
        });
    } catch (err) {
      return dispatch(failure(err));
    }
  };
  function request() {
    return { type: courseConstants.DELETE_SECTION_REQUEST };
  }
  function success(section) {
    return { type: courseConstants.DELETE_SECTION_SUCCESS, section };
  }
  function failure(error) {
    return { type: courseConstants.DELETE_SECTION_FAILURE, error };
  }
}

function deleteLesson(lessonId, sectionId) {
  return dispatch => {
    dispatch(request());
    try {
      db.collection("lessons")
        .doc(lessonId)
        .update({ deleted: true })
        .then(val => {
          const lessonKey = `lessons.${lessonId}`
          db.collection('sections').doc(sectionId).update({ [lessonKey]: '-1' })
          return dispatch(success({ lessonId, sectionId }));
        });
    } catch (err) {
      return dispatch(failure(err));
    }
  };
  function request() {
    return { type: courseConstants.DELETE_LESSON_REQUEST };
  }
  function success(lesson) {
    return { type: courseConstants.DELETE_LESSON_SUCCESS, lesson };
  }
  function failure(error) {
    return { type: courseConstants.DELETE_LESSON_FAILURE, error };
  }
}


function setSubcourseNode(subcourseId, nodeId) {
  return dispatch => {
    dispatch(request())
    db.collection('subcourses').doc(subcourseId).update({ node: nodeId })
      .then(doc => {
        return dispatch(success())
      })
      .catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })
  }

  function request() { return { type: courseConstants.SET_NODE_REQUEST } }
  function success() { return { type: courseConstants.SET_NODE_SUCCESS } }
  function failure(error) { return { type: courseConstants.SET_NODE_FAILURE, error } }
}

function setSectionNode(sectionId, nodeId) {
  return dispatch => {
    dispatch(request())
    db.collection('sections').doc(sectionId).update({ node: nodeId })
      .then(doc => {
        return dispatch(success())
      })
      .catch(err => {
        console.log(err)
        return dispatch(failure(err))
      })
  }

  function request() { return { type: courseConstants.SET_NODE_REQUEST } }
  function success() { return { type: courseConstants.SET_NODE_SUCCESS } }
  function failure(error) { return { type: courseConstants.SET_NODE_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/redux/actions/courses.js